// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18":"ae085994","5918":"7c86c0a8","6082":"085d0cdf","6696":"3fcd979f"}[chunkId] + ".chunk.css";
};